// Imagens da landing page — CURADORIA PORTUGAL (Pexels + Unsplash, todas verificadas a carregar)
// Regra: só fotos que fazem sentido para Portugal — pessoas de aspeto europeu/sul-europeu
// em ambientes de trabalho europeus, e paisagens/cidades portuguesas reais (Lisboa, Porto).
// Nunca usar cenários dos EUA/Ásia, sinalética estrangeira nem fundos de estúdio artificiais.
const U = (id, w) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=${w}`;
const P = (id, w, h) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=${w}&h=${h}`;

// --- Pessoas em contexto de trabalho (Europa / Portugal) ---
const WAITER_ESPLANADA = "1719573019827-d06944a0c2be"; // empregado de mesa numa esplanada europeia
const WAITER_BEBIDAS = "1516788875874-c5912cae7b43"; // bandeja de bebidas em esplanada
const COOK_KITCHEN = "1622021142947-da7dedc7c39a"; // cozinheiro em cozinha profissional
const DRIVER_DELIVERY = "1543499459-d1460946bdc6"; // estafeta com encomenda em rua europeia
const NURSE_CLINIC = "1631815590058-860e4f83c1e8"; // enfermeiro a medir tensão numa clínica
const INTERVIEW_OFFICE = "1698047682091-782b1e5c6536"; // entrevista/recrutamento em escritório
const CONSTRUCTION_SITE = "1595989329151-8c80761a989b"; // trabalhador em andaime
const ABSTRACT_TECH = "1604011237320-8e0506614fdf"; // bokeh abstrato (secção de IA, sem pessoas)
const PORTO_RIBEIRA_URL =
  "https://images.unsplash.com/photo-1768501362994-ecf15566cf53?fm=jpg&q=85&w=1400&auto=format&fit=crop&ixlib=rb-4.1.0";

// Helper para adicionar dimensões a URLs Unsplash sem parâmetros
const uAt = (url, w = 800) => {
  if (!url) return url;
  if (url.includes("?")) return url;
  return `${url}?auto=format&fit=crop&w=${w}&q=80`;
};

const pAt = (url, w = 800) => {
  if (!url) return url;
  if (url.includes("?")) return url;
  return `${url}?auto=compress&cs=tinysrgb&w=${w}`;
};

// --- Galeria de 4 fotos por categoria — para cover das vagas ---
// Curadoria via vision_expert_agent (contexto europeu/português)
export const CATEGORY_GALLERY = {
  restauracao: [
    uAt("https://images.unsplash.com/photo-1577219491135-ce391730fb2c"),
    pAt("https://images.pexels.com/photos/3769740/pexels-photo-3769740.jpeg"),
    uAt("https://images.unsplash.com/photo-1629410486560-d4da23c19905"),
    uAt("https://images.unsplash.com/photo-1653233797467-1a528819fd4f"),
  ],
  logistica: [
    uAt("https://images.unsplash.com/photo-1664382953403-fc1ac77073a0"),
    pAt("https://images.pexels.com/photos/4487419/pexels-photo-4487419.jpeg"),
    uAt("https://images.unsplash.com/photo-1598299803204-b73796f43289"),
    pAt("https://images.pexels.com/photos/4487446/pexels-photo-4487446.jpeg"),
  ],
  retalho: [
    uAt("https://images.unsplash.com/photo-1556742049-0cfed4f6a45d"),
    pAt("https://images.pexels.com/photos/6925800/pexels-photo-6925800.jpeg"),
    uAt("https://images.unsplash.com/photo-1556741574-0ddb65d14311"),
    pAt("https://images.pexels.com/photos/32549955/pexels-photo-32549955.jpeg"),
  ],
  hotelaria: [
    uAt("https://images.unsplash.com/photo-1771812967957-2e32963cc31d"),
    pAt("https://images.pexels.com/photos/3770107/pexels-photo-3770107.jpeg"),
    uAt("https://images.unsplash.com/photo-1580256081112-e49377338b7f"),
    uAt("https://images.unsplash.com/photo-1759038086832-795644825e3a"),
  ],
  limpeza: [
    pAt("https://images.pexels.com/photos/6195274/pexels-photo-6195274.jpeg"),
    pAt("https://images.pexels.com/photos/6196694/pexels-photo-6196694.jpeg"),
    uAt("https://images.unsplash.com/photo-1581578949510-fa7315c4c350"),
    pAt("https://images.pexels.com/photos/34516670/pexels-photo-34516670.jpeg"),
  ],
  "apoio-ao-cliente": [
    uAt("https://images.unsplash.com/photo-1766066014237-00645c74e9c6"),
    pAt("https://images.pexels.com/photos/8867198/pexels-photo-8867198.jpeg"),
    uAt("https://images.unsplash.com/photo-1712159018726-4564d92f3ec2"),
    pAt("https://images.pexels.com/photos/7658369/pexels-photo-7658369.jpeg"),
  ],
  construcao: [
    uAt("https://images.unsplash.com/photo-1504307651254-35680f356dfd"),
    uAt("https://images.unsplash.com/photo-1587582423116-ec07293f0395"),
    uAt("https://images.unsplash.com/photo-1589939705384-5185137a7f0f"),
    pAt("https://images.pexels.com/photos/11293626/pexels-photo-11293626.jpeg"),
  ],
  saude: [
    uAt("https://images.unsplash.com/photo-1584432810601-6c7f27d2362b"),
    pAt("https://images.pexels.com/photos/31499386/pexels-photo-31499386.jpeg"),
    pAt("https://images.pexels.com/photos/6097985/pexels-photo-6097985.jpeg"),
    uAt("https://images.unsplash.com/photo-1666887360680-9dc27a1d2753"),
  ],
  outros: [
    uAt("https://images.unsplash.com/photo-1551434678-e076c223a692"),
    uAt("https://images.unsplash.com/photo-1542744173-8e7e53415bb0"),
    uAt("https://images.unsplash.com/photo-1573164574572-cb89e39749b4"),
    pAt("https://images.pexels.com/photos/7653461/pexels-photo-7653461.jpeg"),
  ],
};

export const MEDIA = {
  // Hero + HowItWorks — profissionais em contexto de trabalho
  heroWorker: U(WAITER_ESPLANADA, 1400),
  warehouse: P(4487365, 1400, 800), // corredor de armazém com operadores
  recruiter: U(INTERVIEW_OFFICE, 1400), // entrevista em escritório europeu
  retail: P(8422706, 1400, 800), // mercearia/loja de bairro com cliente

  // Carrossel Hero — 7 setores, sempre pessoas reais em contexto europeu
  heroSlides: [
    {
      src: U(WAITER_ESPLANADA, 1400),
      alt: "Empregado de mesa a servir numa esplanada",
      sector: "Restauração",
      caption: "Serve, atende e progride — vagas todos os dias",
    },
    {
      src: P(4483938, 1400, 800),
      alt: "Operador de armazém entre estantes de mercadoria",
      sector: "Logística",
      caption: "Operadores, fiéis de armazém e empilhador",
    },
    {
      src: P(8422706, 1400, 800),
      alt: "Lojista a atender um cliente numa mercearia de bairro",
      sector: "Retalho",
      caption: "Loja, caixa e atendimento em todo o país",
    },
    {
      src: P(3771087, 1400, 800),
      alt: "Rececionista ao balcão de um hotel",
      sector: "Hotelaria",
      caption: "Front-office, andares e restauração em hotel",
    },
    {
      src: P(7709231, 1400, 800),
      alt: "Equipa de apoio ao cliente com headsets num escritório",
      sector: "Apoio ao cliente",
      caption: "Português, bilingues e híbrido depois de 3 meses",
    },
    {
      src: U(DRIVER_DELIVERY, 1400),
      alt: "Estafeta a entregar uma encomenda numa rua da cidade",
      sector: "Distribuição",
      caption: "Motoristas e estafetas — carta B, C e C+E",
    },
    {
      src: U(WAITER_BEBIDAS, 1400),
      alt: "Empregado de mesa com bandeja de bebidas",
      sector: "Restauração",
      caption: "Cozinha, sala e bar em contratação contínua",
    },
  ],

  // AI section background (sem pessoas)
  abstractTech: U(ABSTRACT_TECH, 1600),

  // ===== PAISAGENS PORTUGUESAS VERIFICADAS =====
  lisbon: P(1546036, 940, 650),
  lisbonCity: P(31449749, 940, 650),
  lisbonTwilight: P(38042406, 940, 650),
  lisbonAerial: P(30150460, 940, 650),
  portoRibeira: PORTO_RIBEIRA_URL,

  // Setores — 1ª foto de cada galeria (compat legacy) — mantido para landing
  categoryRestauracao: CATEGORY_GALLERY.restauracao[0],
  categoryLogistica: CATEGORY_GALLERY.logistica[0],
  categoryRetalho: CATEGORY_GALLERY.retalho[0],
  categoryHotelaria: CATEGORY_GALLERY.hotelaria[0],
  categoryLimpeza: CATEGORY_GALLERY.limpeza[0],
  categoryApoioCliente: CATEGORY_GALLERY["apoio-ao-cliente"][0],
  categoryConstrucao: CATEGORY_GALLERY.construcao[0],
  categorySaude: CATEGORY_GALLERY.saude[0],
};
